// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReturnCalculator_section__wFEzO {
  margin: 0;
}

.ReturnCalculator_iconCircle__W-UDH {
  width: 11.75rem;
  height: 11.75rem;
  border-radius: 50%;
  background-color: var(--accent-soft);
  color: var(--accent);
  border: 4px solid var(--accent-light);
}

.ReturnCalculator_textCol__57MDx {
  width: 600px;
}

.ReturnCalculator_headline__n0QQ0 {
  color: var(--text);
  font-size: 2.25rem;
  font-weight: 700;
  line-height: 2.5rem;
  letter-spacing: -0.0625rem;
  margin: 0;
}

.ReturnCalculator_figure__-PKxv {
  color: var(--accent);
  text-decoration: underline;
  text-underline-offset: 0.15em;
  text-decoration-thickness: 0.06em;
}

.ReturnCalculator_caption__KWLXm {
  color: var(--text-secondary);
  font-size: 0.875rem;
}

.ReturnCalculator_captionStrong__XCBTl {
  color: var(--text-secondary);
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 0.2em;
}

.ReturnCalculator_sliderWrap__W4ou- {
  max-width: 360px;
  padding-bottom: 2.25rem;
  position: relative;
}

.ReturnCalculator_slider__BbrDl {
  appearance: none;
  width: 100%;
  height: 0.625rem;
  border-radius: 999px;
  background: linear-gradient(
    to right,
    var(--accent) 0 var(--fill),
    var(--track) var(--fill) 100%
  );
  cursor: pointer;
}

.ReturnCalculator_slider__BbrDl:focus-visible {
  outline: 2px solid var(--accent-strong);
  outline-offset: 0.375rem;
}

.ReturnCalculator_slider__BbrDl::-webkit-slider-thumb {
  appearance: none;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-color: var(--accent);
  border: none;
}

.ReturnCalculator_slider__BbrDl::-moz-range-thumb {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-color: var(--accent);
  border: none;
}

.ReturnCalculator_ticks__f4iiv {
  position: absolute;
  inset: auto 0 0.75rem 0;
  height: 1.25rem;
}

.ReturnCalculator_tick__RrBTw {
  position: absolute;
  transform: translateX(-50%);
  color: var(--text-secondary);
  font-size: 0.875rem;
}

.ReturnCalculator_tickActive__LUnZ3 {
  color: var(--text-secondary);
}

@media (max-width: 767.98px) {
  .ReturnCalculator_headline__n0QQ0 {
    font-size: 1.625rem;
    line-height: 2.125rem;
  }

  /* Let the headline wrap naturally instead of breaking after "Your account". */
  .ReturnCalculator_headline__n0QQ0 br {
    display: none;
  }

  /* .textCol is a fixed 600px on desktop; on mobile it has to give. */
  .ReturnCalculator_textCol__57MDx {
    width: auto;
    max-width: 100%;
  }

  .ReturnCalculator_iconCircle__W-UDH {
    width: 7.5rem;
    height: 7.5rem;
    border-width: 3px;
  }

  .ReturnCalculator_iconCircle__W-UDH svg {
    width: 4rem;
    height: 4rem;
  }

  .ReturnCalculator_sliderWrap__W4ou- {
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ReturnCalculator/ReturnCalculator.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB;;;;GAIC;EACD,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA,8EAA8E;EAC9E;IACE,aAAa;EACf;;EAEA,oEAAoE;EACpE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".section {\n  margin: 0;\n}\n\n.iconCircle {\n  width: 11.75rem;\n  height: 11.75rem;\n  border-radius: 50%;\n  background-color: var(--accent-soft);\n  color: var(--accent);\n  border: 4px solid var(--accent-light);\n}\n\n.textCol {\n  width: 600px;\n}\n\n.headline {\n  color: var(--text);\n  font-size: 2.25rem;\n  font-weight: 700;\n  line-height: 2.5rem;\n  letter-spacing: -0.0625rem;\n  margin: 0;\n}\n\n.figure {\n  color: var(--accent);\n  text-decoration: underline;\n  text-underline-offset: 0.15em;\n  text-decoration-thickness: 0.06em;\n}\n\n.caption {\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n}\n\n.captionStrong {\n  color: var(--text-secondary);\n  font-weight: 600;\n  text-decoration: underline;\n  text-underline-offset: 0.2em;\n}\n\n.sliderWrap {\n  max-width: 360px;\n  padding-bottom: 2.25rem;\n  position: relative;\n}\n\n.slider {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 100%;\n  height: 0.625rem;\n  border-radius: 999px;\n  background: linear-gradient(\n    to right,\n    var(--accent) 0 var(--fill),\n    var(--track) var(--fill) 100%\n  );\n  cursor: pointer;\n}\n\n.slider:focus-visible {\n  outline: 2px solid var(--accent-strong);\n  outline-offset: 0.375rem;\n}\n\n.slider::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 2rem;\n  height: 2rem;\n  border-radius: 50%;\n  background-color: var(--accent);\n  border: none;\n}\n\n.slider::-moz-range-thumb {\n  width: 2rem;\n  height: 2rem;\n  border-radius: 50%;\n  background-color: var(--accent);\n  border: none;\n}\n\n.ticks {\n  position: absolute;\n  inset: auto 0 0.75rem 0;\n  height: 1.25rem;\n}\n\n.tick {\n  position: absolute;\n  transform: translateX(-50%);\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n}\n\n.tickActive {\n  color: var(--text-secondary);\n}\n\n@media (max-width: 767.98px) {\n  .headline {\n    font-size: 1.625rem;\n    line-height: 2.125rem;\n  }\n\n  /* Let the headline wrap naturally instead of breaking after \"Your account\". */\n  .headline br {\n    display: none;\n  }\n\n  /* .textCol is a fixed 600px on desktop; on mobile it has to give. */\n  .textCol {\n    width: auto;\n    max-width: 100%;\n  }\n\n  .iconCircle {\n    width: 7.5rem;\n    height: 7.5rem;\n    border-width: 3px;\n  }\n\n  .iconCircle svg {\n    width: 4rem;\n    height: 4rem;\n  }\n\n  .sliderWrap {\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `ReturnCalculator_section__wFEzO`,
	"iconCircle": `ReturnCalculator_iconCircle__W-UDH`,
	"textCol": `ReturnCalculator_textCol__57MDx`,
	"headline": `ReturnCalculator_headline__n0QQ0`,
	"figure": `ReturnCalculator_figure__-PKxv`,
	"caption": `ReturnCalculator_caption__KWLXm`,
	"captionStrong": `ReturnCalculator_captionStrong__XCBTl`,
	"sliderWrap": `ReturnCalculator_sliderWrap__W4ou-`,
	"slider": `ReturnCalculator_slider__BbrDl`,
	"ticks": `ReturnCalculator_ticks__f4iiv`,
	"tick": `ReturnCalculator_tick__RrBTw`,
	"tickActive": `ReturnCalculator_tickActive__LUnZ3`
};
export default ___CSS_LOADER_EXPORT___;
